import { redirect } from 'react-router-dom'
import {
  checkSessionProfileOnce,
  isExpiredSessionResponse,
  isUnauthenticatedSessionResponse,
} from '../services/session-profile-check'
import { loadRuntimeConfig } from '@/lib/runtime-config'
import { expireSessionAndRedirectToLogin } from '../services/session-expiration'

/**
 * Signed-out visitors go to the ProbeStack login. A signed-in user the session service refuses (403) is sent to the
 * landing page, unless `landing` is set: the landing page is where they would be sent, so it shows instead of looping.
 */
async function requireSession({ landing }: { landing: boolean }) {
  const [configResult, profileResult] = await Promise.allSettled([
    loadRuntimeConfig(),
    checkSessionProfileOnce(),
  ])

  if (
    profileResult.status === 'rejected' &&
    isUnauthenticatedSessionResponse(profileResult.reason)
  ) {
    expireSessionAndRedirectToLogin()
    return null
  }
  if (configResult.status === 'rejected') throw configResult.reason
  if (
    !landing &&
    profileResult.status === 'rejected' &&
    isExpiredSessionResponse(profileResult.reason)
  ) {
    return redirect('/')
  }
  return null
}

export function protectedRouteLoader() {
  return requireSession({ landing: false })
}

/** The landing page is for signed-in users too; it never redirects to itself. */
export function protectedLandingLoader() {
  return requireSession({ landing: true })
}
